export default class FiltroConsultarReclamacoes {
    constructor () {
    this.UnidadeId = undefined
    this.ClienteId = undefined
    this.RepresentanteId = undefined
    this.NumeroFormulario = undefined
    this.NumeroPedido = undefined
    }
}